import "reflect-metadata";
import * as Backbone from "backbone";

export function prop<T>(): any;

export function prop<T>(options: DefaultOptions): any;

export function prop<T>(options?: DefaultOptions): any {
    return (target: any, key: string) => {

        const getter = function(): T {
            const type = Reflect.getMetadata("design:type", target, key);
            let value = this.get(key);

            if (options instanceof DefaultOptions) {
                if (!value) {
                    value = type(options.DefaultValue);
                }
            }

            // If the value is undefined or null, don't bother trying to cast it before returning the value
            if (_.contains([undefined, null], value)) {
                return value;
            }

            if (typeof value === "string" && (_.contains(["true", "false"], value.toString().toLowerCase()) || (type && type.name === "Boolean"))) {
                value = value.toString().toLowerCase() === "true";
            } else if (type && _.contains(["String", "Number", "Boolean"], type.name)) {
                value = type(value);
            } else if (type && type.name === "Date") {
                value = new Date(String(value));
            }

            return value;
        };

        const setter = function(value: T) {
            const type = Reflect.getMetadata("design:type", target, key);

            // If the value is undefined or null, don't bother trying to cast it before setting the value
            if (_.contains([undefined, null], value)) {
                this.set(key, value);
                return;
            }

            if (type && _.contains(["String", "Number", "Boolean"], type.name)) {
               this.set(key, type(value));
            } else if (type && type.name === "Date") {
                this.set(key, new Date(String(value)));
            } else {
               this.set(key, value);
            }
        };

        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: true,
            get: getter,
            set: setter
        });
    };
}

export class DefaultOptions extends Backbone.Model {
    @prop() public DefaultValue: string;

    constructor(defaultValue: string) {
        super();
        this.DefaultValue = defaultValue;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/decorators/property.ts